<template>
  <window-content class="e-input-modern label-size-2 size1">
    <div class="wrapper-sm">
      <e-row mr>
        <e-col >
          <erp-s-field
              label="Cliente:"
          >
            <cliente-processo-input v-model="filters.pessoa" @selecionaCliente="adicionarCliente($event, 'cliente')" />
          </erp-s-field>
        </e-col>
<!--        <e-col>
          <erp-s-field label="Tipo do Cliente">
            <autocomplete-multiple load-on-focus :search="searchPersonTags" v-model="filters.classificacao" placeholder="Nenhum" />
          </erp-s-field>
        </e-col>-->
      </e-row>
      <e-row mr>
        <e-col>
          <erp-s-field
              label="Tipo de Envolvido"
          >
            <erp-select
                simple-border
                v-model="filters.tipoEnvolvido"
                :options="[{label: 'Todos', value: null}, ...cache.tiposParte.list]"
                :loading="cache.tiposParte.loading"
            />
          </erp-s-field>
        </e-col>
        <e-col>
          <status-processo-select v-model="filters.statusProcesso" />
        </e-col>
      </e-row>
      <e-row>
        <e-col>
          <tribunal-select v-model="filters.tribunal" />
        </e-col>
      </e-row>
      <e-row>
        <e-col>
          <comarca-select v-model="filters.comarca" :tribunal="filters.tribunal" :limit="10000"/>
        </e-col>
      </e-row>
      <e-row>
        <e-col>
          <vara-select v-model="filters.vara" :comarca="filters.comarca"  />
        </e-col>
      </e-row>
    </div>
    <window-footer class="text-right">
      <div class="inline-block window-actions">
        <u-btn label="Cancelar" icon="chevron-left" icon-type="fa" icon-style="light" flat no-caps
               @click="$uloc.window.close($root.wid)"/>
        <u-btn @click="gerar(formato)" :loading="loading" label="Gerar" icon="print" icon-type="fa" icon-style="light" flat no-caps/>
      </div>
    </window-footer>
  </window-content>
</template>

<script>
import {
  WindowContent,
  WindowHeader,
  WindowBody,
  WindowFooter,
  ErpSField,
  ErpInput,
  HelperInputBtn,
  ErpBox,
  ErpLabel,
  ErpSelect
} from 'uloc-vue-plugin-erp'
import ERow from "@/components/layout/components/Row"
import ECol from "@/components/layout/components/Col"
import {date, URadio} from 'uloc-vue'
import mixinPrint from "@/components/relatorios/components/mixinPrint"
import {relatorio} from "@/domain/relatorios/services"
import {datePtToEn} from "@/utils/date"
import createPrint from "@/components/relatorios/components/customPrint/createPrint"
import GlobalPessoaInput from "@/components/pessoa/components/include/pessoa/PessoaInput"
import StatusTaskSelect from "@/components/sltarefas/components/inputs/StatusTaskSelect"
import TypeTaskSelect from "@/components/sltarefas/components/inputs/TypeTaskSelect"
import TaskPrioritySelect from "@/components/sltarefas/components/inputs/TaskPrioritySelect"
import TribunalSelect from "@/components/processos/components/processos/include/TribunalSelect"
import ComarcaSelect from "@/components/processos/components/processos/include/ComarcaSelect"
import VaraSelect from "@/components/processos/components/processos/include/VaraSelect"
import ClienteProcessoInput from "@/components/processos/components/cliente/input/ClienteProcessoInput"
import {listTiposParte} from "@/domain/processos/services"
import processoMixins from "@/components/processos/components/processos/mixins/ProcessoMixins"
// import AutocompleteMultiple from "@/components/layout/components/AutocompleteMultiple"
import searchTags from "@/components/pessoa/helpers/searchTags"
import StatusProcessoSelect from "@/components/processos/components/processos/include/StatusProcessoSelect"
const MAX_LIMIT_LOAD_SELECTS = 500

let filters = {
  pessoa: null,
  tipoEnvolvido: null,
  classificacao: [],
  statusProcesso: null,
  tribunal: null,
  comarca: null,
  vara: null
}

export default {
  name: 'RelatorioProcessoClientesWindow',
  mixins: [mixinPrint, processoMixins],
  data() {
    return {
      formato: 'html',
      filters: JSON.parse(JSON.stringify(filters)),
      cache: {
        tiposParte: {
          list: [],
          loading: false,
          selected: null
        }
      },
      fakeCliente: null
    }
  },
  mounted() {
    this.loadTiposParte()
  },
  computed: {},
  methods: {
    loadTiposParte () {
      const parameters = [MAX_LIMIT_LOAD_SELECTS, 1, '&sortBy=nome'];
      this.loadCache('tiposParte', listTiposParte, parameters)
    },
    adicionarCliente (cliente) {
      if (!cliente || !cliente.id) return
      console.log('Cliente: ', cliente)
      //this.fakeCliente.id = cliente.id
      //this.fakeCliente.descricao = cliente.name
    },
    searchPersonTags(terms, done) {
      searchTags(terms)
          .then(response => {
            let result = response.data.result.map(p => {
              return {
                ...p,
                label: p.name,
                value: p.name,
                active: null
              }
            })
            done(result)
          }).catch(error => {
        this.alertApiError(error)
      })
    },
    createPrint: createPrint,
    actionPrint (action) {
      console.log('Print Action ', action)
      this.gerar(action)
    },
    gerar(formato = 'html') {
      let data1, data2
      let filters = JSON.parse(JSON.stringify(this.filters))
      if (filters.data1) {
        data1 = datePtToEn(filters.data1)
        data2 = datePtToEn(filters.data2)
        if (!date.isValid(data1) || !date.isValid(data2)) {
          alert('Digite a data inicial e data final corretamente. Formato: dd/mm/yyyy')
          return
        }
        filters.data1 = data1
        filters.data2 = data2
      }
      if (filters.participants && Array.isArray(filters.participants) && filters.participants.length) {
        filters.participants = filters.participants.map(p => p.id)
      }
      if (filters.participants && filters.participants.id) {
        filters.participants = [filters.participants.id]
      }

      this.loading = true
      relatorio('processos.clientes', filters, formato)
          .then(response => {
            this.loading = false
            formato === 'html' && this.createPrint(response.data, () => import('@/components/relatorios/components/customPrint/DefaultPrint'), 'gerencial', 'Clientes', 'landscape')
          })
          .catch(error => {
            this.loading = false
            if (formato === 'html') {
              this.alertApiError(error)
            } else{
              error.data.text().then(text => {
                this.alertApiError({data: JSON.parse(text)})
              })
            }
          })
    }
  },
  components: {
    TribunalSelect,
    VaraSelect,
    ComarcaSelect,
    StatusProcessoSelect,
    // AutocompleteMultiple,
    ClienteProcessoInput,
    ECol,
    ERow,
    WindowFooter,
    // WindowBody,
    // WindowHeader,
    WindowContent,
    ErpSField,
    // ErpInput,
    // HelperInputBtn,
    // ErpBox,
    // ErpLabel
    // UEditor,
    // URadio,
    ErpSelect
  }
}
</script>
